import * as angular from 'angular';
import { Decimal } from 'decimal.js';
import { formatDecimal } from '../../angular/utils/number-helper.util';

(function () {
    'use strict';

    /**
     * @ngdoc filter
     * @name pkpBigDecimal
     * @memberof app
     *
     * @description
     * Turn big decimals from backend services to strings with comma separators for thousandth steps.
     *
     * @param {Object} input An object with an attribute `value` that will be rendered with thousand separators.
     *  The `value` attribute is of type `Decimal`.
     * @returns {string} Thousand comma separated string representation of `input.value`.
     *
     * @author flzemke.btc
     */
    angular.module('app').filter('pkpBigDecimal', pkpBigDecimal);

    function pkpBigDecimal() {
        return function (input) {
            if (!input || !input.value) {
                return input;
            }

            try {
                if (angular.isString(input.value)) {
                    return formatDecimal(
                        new Decimal(input.value.replace(',', ''))
                    );
                } else {
                    return formatDecimal(input.value);
                }
            } catch (e) {
                return input.value;
            }
        };
    }
})();
